import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import {
  BuildingTypeFilterInput,
} from '../../components/search_filters/filters/building_type_filter';
import {
  isNewbuildingsSuggestEnabledForBuildingType,
} from '../../components/search_filters/filters/geo_suggest/suggests_helpers';
import { getOfferType } from '../../components/search_filters/filters/utils';
import { IBuildingTypesConfig } from '../../models/filters/building_types';
import { ISearchType } from '../../models/filters/type';
import { ISearchConfig } from '../../models/search';
import { IStore } from '../../models/store';
import {
  removeBuildingType,
  setBuildingType,
  setDirty,
  togglePopupAutoChangeToSuburban,
} from '../../redux/modules/search/building_types';
import { clearCommercialGeo, clearNewbuildingsGeo } from '../../redux/modules/search/user_geo';
import { GenericFilter } from './generic_filter';

interface IStoreProps {
  type: ISearchType;
  suburbanMultiselectEnabled: boolean; // будет удален в https://cianru.atlassian.net/browse/CD-46983
  canShowPopupAutoChangeToSuburban?: boolean;
}

interface IDispatchProps {
  onChange(type: string, deselect?: boolean): void;
  setDirty(isDirty: boolean): void;
  hidePopupAutoChangeToSuburban(): void;
}

interface IOwnProps {
  buildingType: string[];
  buildingTypes: IBuildingTypesConfig;
  searchConfig: ISearchConfig;
}

interface IProps extends IStoreProps, IDispatchProps, IOwnProps {}

class BuildingTypeFilter extends GenericFilter<IProps> {
  protected setDirty(isDirty: boolean) {
    this.props.setDirty(isDirty);
  }

  public render() {
    const {
      type,
      onChange,
      buildingType,
      buildingTypes,
      searchConfig,
      suburbanMultiselectEnabled,
      hidePopupAutoChangeToSuburban,
      canShowPopupAutoChangeToSuburban,
    } = this.props;

    return (
      <BuildingTypeFilterInput
        type={type.searchType}
        value={buildingType}
        buildingTypes={buildingTypes}
        searchConfig={searchConfig}
        onChange={onChange}
        suburbanMultiselectEnabled={suburbanMultiselectEnabled}
        hidePopupAutoChangeToSuburban={hidePopupAutoChangeToSuburban}
        canShowPopupAutoChangeToSuburban={canShowPopupAutoChangeToSuburban}
      />
    );
  }
}

function mapStateToProps(state: IStore, props: IOwnProps): IStoreProps {
  return {
    type: state.type,
    suburbanMultiselectEnabled: state.buildingType.featureToggleCountrysideOrthodoxParish === 'enabled',
    canShowPopupAutoChangeToSuburban: state.buildingType.canShowPopupAutoChangeToSuburban,
  };
}

function mapDispatchToProps(dispatch: Dispatch, props: IOwnProps): IDispatchProps {
  return {
    onChange: (type: string, deselect?: boolean) => {
      if (deselect) {
        dispatch(removeBuildingType(type));
      } else {
        dispatch(setBuildingType(type));
      }
      // Сбрасываем гео фильтр по ЖК, если комерческая или загородная недвижимость
      if (!isNewbuildingsSuggestEnabledForBuildingType(type)) {
        dispatch(clearNewbuildingsGeo());
      }

      if (getOfferType(type) === 'flat') {
        dispatch(clearCommercialGeo());
      }
    },
    setDirty: (isDirty: boolean) => dispatch(setDirty(isDirty)),
    hidePopupAutoChangeToSuburban() {
      dispatch(togglePopupAutoChangeToSuburban(false));
    },
  };
}

const BuildingTypeFilterWrapper = connect<
  IStoreProps, IDispatchProps, IOwnProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(BuildingTypeFilter as any);

export { BuildingTypeFilterWrapper as BuildingTypeFilter, BuildingTypeFilter as BuildingTypeFilterClass };
